import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/auth-guard.service';
import { RoleGuardService } from './services/role-guard.service';
import { EmailGuardService } from './services/email-guard.service';

//Modules
import { HomeScreenModule } from './screens/home/home.screen.module';
import { LoginScreenModule } from './screens/login/login.screen.module';
import { CompanyDetailScreenModule } from './screens/company-detail/company-detail.screen.module';
import { UserListScreenModule } from './screens/user-list/user-list.screen.module';
import { UserDetailScreenModule } from './screens/user-detail/user-detail.screen.module';
import { UserChooseCompanyScreenModule } from './screens/user-choose-company/user-choose-company.screen.module';
import { CompanyListScreenModule } from './screens/company-list/company-list.screen.module';
import { CompanySummaryScreenModule } from './screens/company-summary/company-summary.screen.module';
import { FaqScreenModule } from './screens/faq/faq.screen.module';
import { VideoTutorialsModule } from './screens/video-tutorials/video-tutorials.module';
import { DownloadScreenModule } from './screens/download/download.screen.module';
import { ProposalsAndOrdersModule } from './screens/proposals-and-orders/proposals-and-orders.screen.module';
import { TrainingsScreenModule } from './screens/trainings/trainings.screen.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => HomeScreenModule,
    pathMatch: 'full',
    canActivate: [AuthGuardService],
  },
  {
    path: 'registration-requests',
    loadChildren: () => HomeScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'login',
    loadChildren: () => LoginScreenModule,
  },
  {
    path: 'users',
    loadChildren: () => UserListScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'users/:userId',
    loadChildren: () => UserDetailScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'users-choose-company',
    loadChildren: () => UserChooseCompanyScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'companies',
    loadChildren: () => CompanyListScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'companies/:companyId',
    loadChildren: () => CompanySummaryScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'companies/:companyId/edit',
    loadChildren: () => CompanyDetailScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'faq',
    loadChildren: () => FaqScreenModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'video-tutorials',
    loadChildren: () => VideoTutorialsModule,
    canActivate: [AuthGuardService],
  },
  {
    path: 'download-stl-file',
    loadChildren: () => DownloadScreenModule,
    canActivate: [AuthGuardService, EmailGuardService],
  },
  {
    path: 'download-stl-file/:analyseId',
    loadChildren: () => DownloadScreenModule,
    canActivate: [AuthGuardService, EmailGuardService],
  },
  {
    path: 'proposals-and-orders',
    loadChildren: () => ProposalsAndOrdersModule,
    canActivate: [AuthGuardService, RoleGuardService],
  },
  {
    path: 'trainings',
    loadChildren: () => TrainingsScreenModule,
    canActivate: [AuthGuardService, RoleGuardService],
  },
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled', relativeLinkResolution: 'legacy' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
